<template>

        <polygon
                :points="polygonpoints"
                :class="[status, {active: active, blink: !$highlight }]"
                :id="eyemoveid"
                @click="polygonSelect"
        ></polygon>

</template>



<script>


    export default {
        props: {
            polygonpoints:{
                type: String
            },
            eyemoveid: {
                type: Number
            },
            mapid: {

            },
            order: {

            },
            index: {
                type: Number
            },
            active: {
                type: Boolean
            }
        },

        data() {
            return {
                status: 'normal',
                buildnr: '',
                objectid: this.eyemoveid,
                polygonStatus: this.polygoonstatus,
                houses: [],
                parent: this.$parent,
            }
        },

        mounted() {
            if(this.eyemoveid){
                this.setHouses()
            }

            if(this.parent.$el.className === 'detail-card') {
                this.parent.activePolygon(this.mapid, this.order);
            }

        },

        methods: {

            setHouses: function () {
                // Push objects in the houses array
                for (var x = 0; x < this.$filteredObjects.length; x++) {
                    var model = this.$filteredObjects[x];
                    this.houses.push(model);
                }

                // Find connection between house id & eyemove_id
                var emid = this.objectid
                var valObj = this.houses.filter(function (object) {
                    return object.id === emid
                }).pop();


                // Get the status from connected arrays
                var statusObj = this.$filteredObjects.filter(function (object) {
                    return object.id === valObj.id
                }).pop();

                this.status = statusObj.status

                // Get the "new" house-id value
                setTimeout(() => {
                    this.buildnr = statusObj.houseindex
                }, 1000)

            },

            polygonSelect(){
                this.parent.$parent.updateStatus(this.buildnr);

                this.$emit('newactive', this.index);

            }
        }
    }
</script>

<style lang="scss" scoped>
  .blink {
    animation-name: blink;
    animation-duration: 3s;

  }

  @keyframes blink {
    0%   {opacity: 0;}
    50%  {opacity: 0.5;}
    100% {opacity: 0;}
  }
</style>
